export const warningsContent = {
    en: {
        MissingPersonalInfo: {
            label: "Warning",
            title: "Missing personal information",
            description:
                'Please add missing personal information. Go to the My Profile page by clicking "My Profile" in the left menu. Then click "Edit data", add all required information, and click the "Save" button at the bottom of the page.',
        },
        EmailNotVerified: {
            label: "Warning",
            title: "Email not verified",
            description:
                'Your email address has not been verified yet. Please open your inbox, find the verification email, and confirm your address. If you cannot find it, request a new verification email.',
        },
        SubscriptionEndingSoon: {
            label: "Warning",
            title: "Subscription ending soon",
            description:
                "Your subscription will end soon. To avoid interruption of access to Revimo, please review your billing settings and renew or update your subscription before the end date.",
        },
        PaymentFailed: {
            label: "Warning",
            title: "Payment failed",
            description:
                "We could not process your latest subscription payment. Please open the billing section, check your payment method, and complete the payment to avoid service interruption.",
        },
        UnfinishedSession: {
            label: "Warning",
            title: "Unfinished session",
            description:
                "You have an unfinished session that still requires your attention. Please return to it and complete all required steps so your work is properly saved and processed.",
        },
        UnsavedChanges: {
            label: "Warning",
            title: "Unsaved changes",
            description:
                "You have unsaved changes on this page. Please save your changes before leaving the page, otherwise your latest updates may be lost.",
        },
        MaintenanceBreakUpcoming: {
            label: "Warning",
            title: "Maintenance break upcoming",
            description:
                "A scheduled maintenance break is coming soon. During this period, some parts of Revimo may be temporarily unavailable. Please finish important work in advance.",
        },
        ServiceDegraded: {
            label: "Warning",
            title: "Service temporarily degraded",
            description:
                "Some platform features are currently working with reduced performance or limited availability. Our team is already working on the issue.",
        },
        PermissionMissing: {
            label: "Warning",
            title: "Missing permission",
            description:
                "You do not currently have permission to access this feature or perform this action. Please contact your workspace administrator if you believe this is a mistake.",
        },
        SuspiciousLoginDetected: {
            label: "Warning",
            title: "Suspicious login detected",
            description:
                "We detected a login attempt or account activity that appears unusual. Please review your recent account activity and change your password if needed.",
        },
    },
    sl: {
        MissingPersonalInfo: {
            label: "Opozorilo",
            title: "Manjkajoči osebni podatki",
            description:
                'Prosimo, dodajte manjkajoče osebne podatke. Pojdite na stran Moj profil s klikom na "Moj profil" v levem meniju. Nato kliknite "Uredi podatke", dodajte vse zahtevane podatke in na dnu strani kliknite gumb "Shrani".',
        },
        EmailNotVerified: {
            label: "Opozorilo",
            title: "E-poštni naslov ni potrjen",
            description:
                "Vaš e-poštni naslov še ni potrjen. Odprite svoj e-poštni predal, poiščite potrditveno sporočilo in potrdite svoj naslov. Če sporočila ne najdete, zahtevajte novo potrditveno e-pošto.",
        },
        SubscriptionEndingSoon: {
            label: "Opozorilo",
            title: "Naročnina se kmalu izteče",
            description:
                "Vaša naročnina se bo kmalu iztekla. Da ne bi prišlo do prekinitve dostopa do Revimo platforme, preverite obračunske podatke in pravočasno podaljšajte ali posodobite naročnino.",
        },
        PaymentFailed: {
            label: "Opozorilo",
            title: "Plačilo ni uspelo",
            description:
                "Zadnjega plačila naročnine nismo mogli obdelati. Odprite razdelek za obračun, preverite način plačila in dokončajte plačilo, da ne pride do prekinitve storitve.",
        },
        UnfinishedSession: {
            label: "Opozorilo",
            title: "Nedokončana seja",
            description:
                "Imate nedokončano sejo, ki še zahteva vašo pozornost. Vrnite se vanjo in dokončajte vse zahtevane korake, da bo vaše delo pravilno shranjeno in obdelano.",
        },
        UnsavedChanges: {
            label: "Opozorilo",
            title: "Neshranjene spremembe",
            description:
                "Na tej strani imate neshranjene spremembe. Preden zapustite stran, jih shranite, sicer se lahko vaše zadnje posodobitve izgubijo.",
        },
        MaintenanceBreakUpcoming: {
            label: "Opozorilo",
            title: "Prihaja vzdrževalni odmor",
            description:
                "Kmalu bo potekal načrtovan vzdrževalni odmor. V tem času bodo lahko nekateri deli Revimo platforme začasno nedostopni. Pomembno delo zaključite vnaprej.",
        },
        ServiceDegraded: {
            label: "Opozorilo",
            title: "Storitev je začasno omejena",
            description:
                "Nekatere funkcije platforme trenutno delujejo počasneje ali so omejeno dostopne. Naša ekipa težavo že odpravlja.",
        },
        PermissionMissing: {
            label: "Opozorilo",
            title: "Manjkajoče dovoljenje",
            description:
                "Trenutno nimate dovoljenja za dostop do te funkcije ali izvedbo tega dejanja. Če menite, da gre za napako, se obrnite na skrbnika vašega delovnega prostora.",
        },
        SuspiciousLoginDetected: {
            label: "Opozorilo",
            title: "Zaznana sumljiva prijava",
            description:
                "Zaznali smo poskus prijave ali dejavnost na računu, ki se zdi nenavadna. Preglejte nedavno dejavnost računa in po potrebi spremenite geslo.",
        },
    },
} as const;